/**
 * ブラウザの自動翻訳（Google翻訳）やDOMを書き換える拡張機能対策。
 *
 * これらはReactが管理しているテキストノードを `<font>` などに差し替えるため、
 * 後からReactが `removeChild` / `insertBefore` しようとすると
 * 「The node to be removed is not a child of this node」エラーで
 * 画面全体がクラッシュする。
 *
 * 対象ノードが既に別の親に移動／除去されている場合は、例外を投げずに
 * 安全にスキップするようガードする。Reactの公式issueで案内されている回避策。
 * @see https://github.com/facebook/react/issues/11538
 */
export function applyDomSafePatch(): void {
  if (typeof Node !== 'function' || !Node.prototype) return

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[domSafePatch] removeChild: 子ノードの親が一致しないためスキップしました', child, this)
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[domSafePatch] insertBefore: 参照ノードの親が一致しないため末尾に追加しました', referenceNode, this)
      }
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
